import { render, staticRenderFns } from "./PlaygroundGroup.vue?vue&type=template&id=4b60c029&scoped=true&"
import script from "./PlaygroundGroup.vue?vue&type=script&lang=js&"
export * from "./PlaygroundGroup.vue?vue&type=script&lang=js&"
import style0 from "./PlaygroundGroup.vue?vue&type=style&index=0&id=4b60c029&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b60c029",
  null
  
)

export default component.exports